module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C96"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C97"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_A_Note_on_the_Title#page_ix"
    }
  }, [_vm._v("A Note on the Title")])])]), _vm._v(" "), _c('p', {
    staticClass: "C97"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Acknowledgments#page_xi"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C97"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/08_A_Novelist_Reads_the_Talmud__An#page_xiii"
    }
  }, [_vm._v("A Novelist Reads the Talmud: An Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "C100"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Timeline_of_Relevant_Events__Acc#page_xxi"
    }
  }, [_vm._v("Timeline of Relevant Events, According to Rabbinic Tradition")])])]), _vm._v(" "), _c('p', {
    staticClass: "C97"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_MEMO_ONE__Rabbi_Yohanan_and_Rabb#page_1"
    }
  }, [_vm._v("MEMO ONE. Rabbi Yohanan and Rabbi Shimon ben Lakish")])]), _vm._v(" "), _c('p', {
    staticClass: "C97"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_CHAPTER_1__Eros_and_Alchemy_in_t#page_3"
    }
  }, [_vm._v("CHAPTER 1. Eros and Alchemy in the Waters of the Jordan")])]), _vm._v(" "), _c('p', {
    staticClass: "C97"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_MEMO_TWO__Rabbi_Shimon_bar_Yohai#page_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEMO TWO. Rabbi Shimon bar Yohai")])]), _vm._v(" "), _c('p', {
    staticClass: "C97"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_CHAPTER_2__Turning_the_Hearts_of#page_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 2. Turning the Hearts of Fathers")])]), _vm._v(" "), _c('p', {
    staticClass: "C97"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_MEMO_THREE_A__B__AND_C__Rabbi_El#page_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEMO THREE A, B, AND C. Rabbi Elazar ben Rabbi Shimon, Rabbi Pinhas ben Yair, and Rabbi Judah ben Gerim")])]), _vm._v(" "), _c('p', {
    staticClass: "C97"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_CHAPTER_3__Towards_the_Hearts_of#page_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3. Towards the Hearts of Sons")])]), _vm._v(" "), _c('p', {
    staticClass: "C97"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_MEMO_FOUR__Rabban_Gamliel_II_of#page_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEMO FOUR. Rabban Gamliel II of Yavneh, Rabbi Joshua ben Hananiah, and Rabbi Eliezer ben Hyrcanus")])]), _vm._v(" "), _c('p', {
    staticClass: "C97"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_CHAPTER_4__The_Gate_of_a_Broken#page_124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4. The Gate of a Broken Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "C97"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_MEMO_FIVE__Rabbi_Akiva__Shimon_b#page_169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEMO FIVE. Rabbi Akiva, Shimon ben Azzai, Shimon ben Zoma, and Elisha ben Avuyah")])]), _vm._v(" "), _c('p', {
    staticClass: "C100"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_CHAPTER_5__Revelation__Retributi#page_170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5. Revelation, Retribution, Perdition, Ecstasy, and Bliss: An Epic Canvas")])]), _vm._v(" "), _c('p', {
    staticClass: "C97"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Endnotes#page_219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C97"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Glossary#page_235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40baeeb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 72
// module chunks = 0